export const aboutData = {
    title: "Who I am",
    description1: "Hey Everyone!! Arijit this side",
    description2: "I am a BCA (Bachelor of Computer Applications) graduate from Institute of Engineering & Management, Kolkata, with a focus on Backend Web Development and Cloud Computing. After I joined Deloitte, I received training on Web Development Foundations, Qualtrics and Medallia. I am keen to work on projects that will allow me to apply my skills and continue to grow.",
    image: 2
}
